/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1Tag202,
  PostApiV1Tag400,
  PostApiV1Tag401,
  PostApiV1Tag404,
  PostApiV1Tag500,
  PostApiV1TagMutationRequest,
  PostApiV1TagMutationResponse,
} from "../../types/tagRegistroController/PostApiV1Tag.ts";
import { createTagRequestViewModelSchema } from "../createTagRequestViewModelSchema.ts";
import { tagViewModelSchema } from "../tagViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1Tag202Schema = z.lazy(
  () => tagViewModelSchema,
) as unknown as ToZod<PostApiV1Tag202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1Tag400Schema =
  z.any() as unknown as ToZod<PostApiV1Tag400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1Tag401Schema =
  z.any() as unknown as ToZod<PostApiV1Tag401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1Tag404Schema =
  z.any() as unknown as ToZod<PostApiV1Tag404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1Tag500Schema =
  z.any() as unknown as ToZod<PostApiV1Tag500>;

export const postApiV1TagMutationRequestSchema = z.lazy(
  () => createTagRequestViewModelSchema,
) as unknown as ToZod<PostApiV1TagMutationRequest>;

export const postApiV1TagMutationResponseSchema = z.lazy(
  () => postApiV1Tag202Schema,
) as unknown as ToZod<PostApiV1TagMutationResponse>;
